let callback,timeoutID,x,minutes;
function _timeoutEvent(){
  timeoutID = null;
  console.log('Session timed out');
  sessionStorage.removeItem('active');
  removeEventListener("mousemove", _restartSession);
  callback();
}

const _restartSession = () => {
  clearTimeout(timeoutID);
  sessionStorage.setItem('active', `session-${Date.now()}`);
  let timeout = 60000 * minutes;
  timeoutID = setTimeout(_timeoutEvent, timeout);
};

function _mouse (element, delay, callback) {
// Function copied from https://stackoverflow.com/questions/609965/detecting-when-the-mouse-is-not-moving
  // Counter Object
  element.ms = {};

  // Counter Value
  element.ms.x = 0;

  // Counter Function
  element.ms.y = function () {

     // Callback Trigger
     if ((++element.ms.x) == delay) element.ms.callback(element, element.ms);
  };

  // Counter Callback
  element.ms.callback = callback;

  // Function Toggle
  element.ms.toggle = function (state) {

     // Stop Loop
     if ([0, "off"][state]) clearInterval(element.ms.z);

     // Create Loop
     if ([1, "on"][state]) element.ms.z = setInterval(element.ms.y, 1);
  };

  // Function Disable
  element.ms.remove = function () {

     // Delete Counter Object
     element.ms = null; return delete element.ms;
  };

  // Function Trigger
  element.onmousemove = function () {

     // Reset Counter Value
     element.ms.x = -1;
  };

  // Return
  return element.ms;
}

export const setupSessionTimeout = (cb = callback, min = minutes) =>{
  callback = cb;
  minutes = min;
  sessionStorage.setItem('active', `session-${Date.now()}`);
  onkeyup = _restartSession;
  onmouseup = _restartSession;
  addEventListener("mousemove", _restartSession);
  x = _mouse(document, 10, _restartSession);
  x.toggle(1); 
};
// END
